import React, { useEffect } from 'react';
import styled from 'styled-components';

import WhatsappBtn from '../../components/common/WhatsappBtn';
import LoginPorvenir from '../../components/templates/incompany/porvenir/LoginPorvenir';
import PublicityWithoutPorvenir from '../../components/templates/incompany/porvenir/PublicityWithout';

const PorvenirIC = () => {
    useEffect(() => {
        localStorage.clear();
    }, []);

    return (
        <LoginPageContainer>
            <PublicityWithoutPorvenir />
            <LoginPorvenir />
            <WhatsappBtn x="right: 7rem" y="bottom: 1.5rem" />
        </LoginPageContainer>
    );
};

export default PorvenirIC;

const LoginPageContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    height: 100vh;

    @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        div {
            height: 100%;
        }
    }
`;
